import http from './http-common';
import {
  CreateTenantWorkOrderSubmissionRequest,
  TenantWorkOrderSubmission,
  UpdateTenantWorkOrderSubmissionRequest,
} from 'vendor-marketplace-shared-library';

class TenantWorkOrderSubmissionService {
  async createTenantWorkOrderSubmission(
    submission: CreateTenantWorkOrderSubmissionRequest,
  ): Promise<TenantWorkOrderSubmission> {
    const response = await http.post('/tenant/work-order/create', submission);
    return response.data;
  }

  async updateTenantWorkOrderSubmission(
    submission: UpdateTenantWorkOrderSubmissionRequest,
  ): Promise<TenantWorkOrderSubmission> {
    const response = await http.post('/tenant/work-order/update', submission);
    return response.data;
  }
}

const tenantWorkOrderSubmissionService = new TenantWorkOrderSubmissionService();

export default tenantWorkOrderSubmissionService;
